import { FC } from 'react'

import { Button, Typography } from '@/components/ui'

import ArrowRight from '@/assets/icons/arrow-right.svg'

import { STEP_TYPE } from '@/constants/common'

interface IModalSelectWayProps {
	setSelectedWay: (way: string) => void
	isMP4?: boolean
	filename?: string
}

const ModalSelectWay: FC<IModalSelectWayProps> = ({
	setSelectedWay,
	isMP4,
	filename
}) => {
	return (
		<div className='flex justify-center'>
			<div>
				<Typography
					variant='text-xlarge'
					className='!leading-[40px] !font-[700] mb-2'
				>
					Get your file ready
				</Typography>
				<Typography variant='text' className='text-[16px] mb-6'>
					Choose how to process the file: {filename || 'Hello'}
				</Typography>
				<div className='flex flex-col gap-4'>
					<Button
						className='!w-[525px] bg-gray-100 rounded-[8px] px-4 py-[14px] hover:bg-gray-200'
						classNameText='flex w-full justify-between text-black text-[16px] font-semibold'
						onClick={() => {
							setSelectedWay(STEP_TYPE.UPLOAD)
						}}
						disabled={!isMP4}
					>
						<span className='inline-block'>Upload</span>
						<ArrowRight />
					</Button>
					<Button
						className='!w-[525px] bg-gray-100 rounded-[8px] px-4 py-[14px] hover:bg-gray-200'
						classNameText='flex w-full justify-between text-black text-[16px] font-semibold'
						onClick={() => {
							setSelectedWay(STEP_TYPE.TRANSCRIBE)
						}}
					>
						<span className='inline-block'>Transcribe</span>
						<ArrowRight />
					</Button>
				</div>
			</div>
		</div>
	)
}

export default ModalSelectWay
